"use client";
export var ReducerActionType;
(function (ReducerActionType) {
    ReducerActionType[ReducerActionType["SET"] = 0] = "SET";
    ReducerActionType[ReducerActionType["REMOVE"] = 1] = "REMOVE";
})(ReducerActionType || (ReducerActionType = {}));
export const setAction = (key, value, options) => ({
    type: ReducerActionType.SET,
    key,
    value,
    options,
});
export const removeAction = (key, options) => ({
    type: ReducerActionType.REMOVE,
    key,
    options,
});
//# sourceMappingURL=reducer.js.map